import { render, staticRenderFns } from "./ContactActionsActivity.vue?vue&type=template&id=78d2f64c&scoped=true&"
var script = {}
import style0 from "./ContactActionsActivity.vue?vue&type=style&index=0&id=78d2f64c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d2f64c",
  null
  
)

export default component.exports